package one.healthium.onboarding.domain.screens

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ScreensGroupModel(
    @SerialName("screens") val screens: List<ScreenDefinition>
)